import { ReactNode } from 'react';

export type Order = 'asc' | 'desc';

export type TableData =
  | string
  | number
  | string[]
  | number[]
  | boolean;

export type TableType = {
  id: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;

export type RowErrors<T extends TableType> = Record<
  number,
  Partial<Record<keyof T, string>> & { _row?: string }
>;

export type ColumnDef<T extends TableType> = {
  label: ReactNode;
  width?: number | string;
  align?: 'left' | 'right' | 'center';
  field?: keyof T;
  sortable?: boolean;
  render?: (row: T, value?: TableData) => ReactNode;
  editable?: boolean;
  required?: boolean;
  onChange?: (id: number, value: TableData) => void;
  id?: string;
  formatError?: (error: string, row: T) => string;
};

export type HeadCell<T extends TableType> = ColumnDef<T>;

export function descendingComparator<T>(
  a: T,
  b: T,
  orderBy: keyof T | null,
) {
  if (orderBy === null) {
    return 0;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<T>(
  order: Order,
  orderBy: keyof T | null,
): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
